import { render, staticRenderFns } from "./ManageUsersRoles.vue?vue&type=template&id=0f8c0214&"
import script from "./ManageUsersRoles.vue?vue&type=script&lang=js&"
export * from "./ManageUsersRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports